import './assets/css/App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from './layouts/admin';
import WidgetPreview from './views/admin/preview/WidgetPreview';
import ProtectedRoute from './components/ProtectedRoute';
import AmplifyAuth from './layouts/auth/AmplifyAuth';
import {
  ChakraProvider,
  Spinner,
  Center
} from '@chakra-ui/react';
import initialTheme from './theme/theme';
import { useState, useEffect, createContext } from 'react';
import { useAuthUser } from './services/AuthenticationHook';

// Create the authentication context
export const AuthContext = createContext(null);

export default function Main() {
  const [currentTheme, setCurrentTheme] = useState(initialTheme);
  
  // Use our custom auth hook
  const authState = useAuthUser();
  const { isLoading: authHookLoading } = authState;
  
  // Check initial auth state when app loads
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    // Give a brief delay to avoid flicker on initial load
    setTimeout(() => {
      setInitialLoading(false);
    }, 300);
  }, []);

  // Show loading when either initial load or auth hook is loading
  if (initialLoading || authHookLoading) {
    return (
      <ChakraProvider theme={currentTheme}>
        <Center h="100vh">
          <Spinner size="xl" color="blue.500" />
        </Center>
      </ChakraProvider>
    );
  }

  return (
    <AuthContext.Provider value={authState}>
      <ChakraProvider theme={currentTheme}>
        <Routes>
          {/* Auth routes - Only keep AmplifyAuth */}
          <Route path="auth/sign-in" element={<AmplifyAuth />} />
          
          {/* Public preview route */}
          <Route path="preview" element={<WidgetPreview />} />
          
          {/* Protected admin routes */}
          <Route
            path="admin/*"
            element={
              <ProtectedRoute>
                <AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />
              </ProtectedRoute>
            }
          />
          
          {/* Default route redirects to admin */}
          <Route path="/" element={<Navigate to="/admin" replace />} />
          
          {/* Catch all other routes */}
          <Route path="*" element={<Navigate to="/auth/sign-in" replace />} />
        </Routes>
      </ChakraProvider>
    </AuthContext.Provider>
  );
}